import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { apiClient } from "../../lib/api-client";

export interface TransferRow {
  id: string;
  fromUserId: string | null;
  toUserId: string;
  transferredBy: string;
  reason: string | null;
  createdAt: string;
}

interface ListResponse { transfers: TransferRow[] }

export function useTransfersQuery(workspaceSlug: string | null, leadId: string | undefined) {
  return useQuery({
    enabled: !!workspaceSlug && !!leadId,
    queryKey: ["transfers", workspaceSlug, leadId],
    queryFn: () =>
      apiClient.get<ListResponse>(`/api/transfers/lead/${leadId}`, {
        params: { workspace: workspaceSlug ?? undefined },
      }),
  });
}

export function useTransferLead(workspaceSlug: string | null) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (input: { leadId: string; toUserId: string; reason?: string }) =>
      apiClient.post("/api/transfers", {
        params: { workspace: workspaceSlug ?? undefined },
        json: input,
      }),
    onSuccess: (_data, vars) => {
      void qc.invalidateQueries({ queryKey: ["transfers", workspaceSlug, vars.leadId] });
      void qc.invalidateQueries({ queryKey: ["activities", workspaceSlug, vars.leadId] });
      void qc.invalidateQueries({ queryKey: ["leads", workspaceSlug] });
    },
  });
}

export function useClaimLead(workspaceSlug: string | null) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (input: { leadId: string }) =>
      apiClient.post("/api/transfers/claim", {
        params: { workspace: workspaceSlug ?? undefined },
        json: input,
      }),
    onSuccess: (_data, vars) => {
      void qc.invalidateQueries({ queryKey: ["leads", workspaceSlug] });
      void qc.invalidateQueries({ queryKey: ["activities", workspaceSlug, vars.leadId] });
    },
  });
}
